module.exports = __webpack_public_path__ + "static/media/16.636e333d.jpg";